import styled, { css } from "styled-components";
import { DropdownChildWrapper } from "../../../../../../../../common-deprecated/components/dropdown/DropdownContentStyles";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";
// import * as ButtonSliderStyles from "../../../../../../common/components/aem/lexus/filters/ButtonSlider/styles/ButtonSliderStyles";
import * as FinanceToggle from "../../../../../../../../common-deprecated/styles/v2/lexus/components/FinanceToggle";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as FilterResultStyles from "../../../filters/styles/FilterResultStyles";
import * as FilterDescriptionStyles from "../../../../../../../../common-deprecated/features/filters/components/lexus/filters/FilterDescription/styles/FilterDescriptionStyles";
import * as ButtonSliderStyles from "../../../common/styles/ButtonSliderStyles";

// ----------------------------------------------------------------------
// General
// ----------------------------------------------------------------------
export const Wrapper = styled.div<{ left: number; top: number }>`
    position: absolute;
    width: 440px;
    padding: 0;
    background: ${theme.colors.white};
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
    z-index: ${theme.zIndex.popover + 1};
    ${({ top, left }) => css`
        top: ${top}px;
        left: ${left}px;
        transform: ${left > 0 ? "transform: translateX(-50%);" : "none"};
    `};

    ${DropdownChildWrapper} {
        background-color: ${theme.colors.white};
    }

    @media ${getBreakpoint("down", "md")} {
        position: fixed;
        top: 0;
        ${getDirection("left")}: 0;
        width: 100%;
        height: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
`;

export const Backdrop = styled.div`
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: "";
    background: ${theme.colors.azure};
    opacity: 0.25;
    z-index: ${theme.zIndex.modalBackdrop};
`;

export const Body = styled.div`
    padding: 0 ${theme.space[3]}px ${theme.space[4]}px;

    @media ${getBreakpoint("down", "md")} {
        height: calc(100% - 62px); /* Height viewport (100%) - height Header (62px) */
        overflow-y: auto;
    }

    ${FinanceToggle.Wrapper} {
        margin-top: ${theme.space[1]}px;
    }

    ${ButtonSliderStyles.default} {
        &::after {
            background-color: ${theme.colors.silver}; /* Specific style */
        }
    }

    /* Set dark variant from components */
    ${FilterResultStyles.Label} {
        color: ${theme.colors.azure};
    }
    ${FilterResultStyles.Value} {
        color: ${theme.colors.midnight};
    }
    ${FilterDescriptionStyles.Title} {
        color: ${theme.colors.azure};
    }
    ${ButtonSliderStyles.Handle} {
        background: ${theme.colors.white};
        border-color: ${theme.colors.azure};
        &::after {
            background: ${theme.colors.white};
        }
    }
    ${ButtonSliderStyles.Track} {
        background: ${theme.colors.azure};
    }
`;

export const ResultCount = styled.span``;

// ----------------------------------------------------------------------
// Footer
// ----------------------------------------------------------------------
export const ShowFilters = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 70px;
    padding: ${theme.space[3]}px 0;
    font-family: ${theme.fonts.bold};
    font-size: 1.4rem;
    letter-spacing: 0.2rem;
    line-height: 2.2rem;
    text-transform: uppercase;
    color: ${theme.colors.azure};
    background: ${theme.colors.mist};
    border: none;
`;
